/* eslint-disable @next/next/no-img-element */
import { useState } from "react";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Link from "next/link";
import router from "next/router";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useToggleSidebar } from "hooks/useToggleSidebar";
import { getSession } from "utils/auth";
import { isClient } from "utils/generic-utils";
import {
   DashboardSidebarContainer,
   SidebarLink,
   SidebarLinks,
   SidebarChildLink,
   ChildSideLink,
   ParentSideLink,
   BrandHolder,
   DashboardSidebarMainContainer,
} from "./dashboard-sidebar.style";
import { useCurrentSideLinks } from "./links";

const DashboardSidebar = () => {
   const { currentLinks } = useCurrentSideLinks();
   const { user } = getSession();
   const { toggle, setToggleSidebar } = useToggleSidebar();

   function handleFullVisibility() {
      setToggleSidebar();
   }

   return (
      <DashboardSidebarMainContainer fullVisibility={toggle}>
         <button className="dashboard__drawer--icon-container" onClick={handleFullVisibility}>
            <MdKeyboardArrowRight className="dashboard__drawer--icon" />
         </button>
         <DashboardSidebarContainer fullVisibility={toggle}>
            <SidebarLinks fullVisibility={toggle}>
               <BrandHolder fullVisibility={toggle}>
                  <Link href="/" passHref>
                     <div>
                        <img src="/images/admin.png" alt="icon" />
                        <span>{user?.type?.replace(/\_/gi, " ")}</span>
                     </div>
                  </Link>
               </BrandHolder>
               {currentLinks?.map((link: any) => {
                  return <LinksComponent key={link?.label} link={link} fullVisibility={toggle} />;
               })}
            </SidebarLinks>
         </DashboardSidebarContainer>
      </DashboardSidebarMainContainer>
   );
};

export const LinksComponent = ({ link, fullVisibility }: any) => {
   const [visibility, setVisibility] = useState(link?.url === "#/admin/school/add");

   const CurrentLink = link?.url.includes("#/") ? "a" : Link;

   return (
      <SidebarLink key={link?.label}>
         <CurrentLink
            href={link?.url}
            passHref={!link?.url.includes("#/")}
            className="a-link"
            onClick={() => setVisibility(!visibility)}
            onKeyPress={() => setVisibility(!visibility)}
         >
            <ParentSideLink
               fullVisibility={fullVisibility}
               active={isClient && router.pathname.includes(link?.url)}
            >
               <div className="img-container">
                  <img src={link?.icon as any} alt={link?.label as any} />
               </div>
               <span>{link?.label}</span>
               {link?.children?.length > 0 && (
                  <KeyboardArrowDownIcon
                     role="button"
                     style={{
                        fontSize: "20px",
                        height: "100%",
                        marginLeft: "auto",
                        justifySelf: "flex-end",
                        position: "relative",
                        top: "3px",
                        border: "1px solid",
                        borderRadius: "10px",
                     }}
                     className={`icon ${visibility ? "rotate" : ""}`}
                  />
               )}
            </ParentSideLink>
         </CurrentLink>
         <SidebarChildLink visibility={!visibility || fullVisibility}>
            {link?.children?.map((child: any) => (
               <Link href={child.url} key={child.label} passHref>
                  <ChildSideLink fullVisibility={fullVisibility}>{child.label}</ChildSideLink>
               </Link>
            ))}
         </SidebarChildLink>
      </SidebarLink>
   );
};

export { DashboardSidebar };
